export const FOLLOW_UP_PROMPT_EVENT = "followup-prompt:open";

export const openFollowupDashboardPopup = () => {
  const popupWidth = 1200;
  const popupHeight = 820;
  const popupTop = Math.max(0, Math.floor((window.screen.height - popupHeight) / 2));
  const popupLeft = Math.max(0, Math.floor((window.screen.width - popupWidth) / 2));

  const popupWindow = window.open(
    "/followup-dashboard",
    "followup-report-popup",
    `popup=yes,width=${popupWidth},height=${popupHeight},top=${popupTop},left=${popupLeft},resizable=yes,scrollbars=yes`
  );

  if (popupWindow) {
    popupWindow.focus();
    return true;
  }

  return false;
};

// seed: dados já conhecidos de quem disparou o prompt, no mesmo formato que o
// AgendamentoModal aceita ({ cliente, clienteId, contatoId, ... }) — evita o
// atendente reescolher cliente/contato que o sistema acabou de usar.
export const requestFollowUpPrompt = (sourceLabel = "item", seed = null) => {
  return new Promise((resolve) => {
    window.dispatchEvent(
      new CustomEvent(FOLLOW_UP_PROMPT_EVENT, {
        detail: {
          sourceLabel,
          seed,
          onResolve: (answer) => resolve(Boolean(answer)),
        },
      })
    );
  });
};
